import { RequestFactory } from '../../api/RequestFactory';
import queryString = require('query-string');
import { apiUrl } from '../../api/config';

const inventoryFactory = new RequestFactory(apiUrl);

const apiKey = queryString.parse(location.search).apiKey;

if (apiKey) {
    inventoryFactory.setApiKey(apiKey);
}

export default inventoryFactory;


// WEBPACK FOOTER //
// ./src/actions/inventory/requestFactory.ts